<template>
    <stats-card :title="title"
                :type="'gradient-'+type"
                class="mb-4 mb-xl-0">
        <template v-slot:header v-if="showHeader">
            <div class="row align-items-center">
                <div class="col">
                    <h6 class="text-uppercase text-muted ls-1 mb-1">Servicedesk</h6>
                </div>
                <div class="col-auto">
                    <div class="icon icon-shape"><i class="fad fa-tasks text-success" aria-hidden="true"></i></div>
                </div>
            </div>
            <hr class="mb-3 mt-1">
        </template>
        <div class="row mb-5">
            <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Kategorien</h6>
                <h5 class="h3 mb-0">Fallverteilung</h5>
            </div>
            <div class="col text-right">
                <el-select
                    class="select-primary pagination-select mr-3"
                    v-model="activePie"
                    default-first-option>

                    <el-option
                        class="select-primary"
                        v-for="(yearData, index) in topdeskData"
                        :key="index"
                        :label="index"
                        :value="index"
                    >
                    </el-option>
                </el-select>
            </div>
        </div>
        <PieChart theme="light" ref="pieChart"/>
        <span v-if="error.length > 0" class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        <template v-slot:footer>
        </template>
    </stats-card>
</template>
<script>
import {ref, watch, onMounted} from 'vue';
import {
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption
} from "element-plus";
import Card from '@/components/Cards/Card';
import UserService from '@/services/user.service';
import PieChart from '@/components/Charts/PieChart'
import moment from 'moment';
import 'moment/locale/de';

export default {
    name: 'IncidentChartCategory',
    components: {
        Card,
        PieChart,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
    },
    props: {
        type: {
            type: String,
            default: "orange"
        },
        title: {
            type: String,
            default: "Kategorien"
        },
        showHeader: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const error = ref('');

        function getError(request) {
            if (request.response && request.response.status == '401') {
                error.value = 'you are not logged in!';
            } else if (request.response && request.response.status == '403') {
                error.value = 'you are not permitted!';
            } else {
                error.value =
                    (request.response && request.response.data) ||
                    request.message ||
                    request.toString();
            }
        }

        const activePie = ref('');
        const topdeskData = ref({});

        const incidentPieChart = ref({
            chartData: {
                name: '',
                labels: [],
                datasets: []
            }
        });

        function getChartData() {
            UserService.getIncidents(0, 10000).then(
                response => {
                    response.data.data.forEach(incident => {
                        const labelOption = {
                            show: true,
                            position: 'insideBottom',
                            distance: 15,
                            align: 'left',
                            verticalAlign: 'middle',
                            rotate: '90',
                            formatter: '{c}  {name|{a}}',
                            fontSize: 16,
                            rich: {
                                name: {}
                            }
                        };
                        const pieChartData = {
                            labels: [],
                            datasets: [],
                        };
                        if (!(moment(incident.creationDate).format('YYYY') in topdeskData.value)) {
                            topdeskData.value[moment(incident.creationDate).format('YYYY')] = {
                                pieChartData: pieChartData
                            };
                        }
                        if (!incident.category && topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.labels.indexOf('Nicht gesetzt') === -1) {
                            topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.labels.push('Nicht gesetzt');
                            topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.datasets[topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.labels.indexOf('Nicht gesetzt')] = {
                                value: 0,
                                name: 'Nicht gesetzt'
                            };
                        }
                        if (incident.category && topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.labels.indexOf(incident.category.name) === -1) {
                            topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.labels.push(incident.category.name);
                            topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.datasets[topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.labels.indexOf(incident.category.name)] = {
                                value: 0,
                                name: incident.category.name
                            };
                        }
                        if (incident.category) {
                            topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.datasets[topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.labels.indexOf(incident.category.name)].value++;
                        } else {
                            topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.datasets[topdeskData.value[moment(incident.creationDate).format('YYYY')].pieChartData.labels.indexOf('Nicht gesetzt')].value++;
                        }
                    });
                    activePie.value = Object.keys(topdeskData.value)[Object.keys(topdeskData.value).length - 1];
                },
                error => {
                    getError(error);
                }
            );
        }

        const pieChart = ref({});

        watch(activePie, () => {
            if (topdeskData.value && Object.keys(topdeskData.value).length > 0) {
                incidentPieChart.value.chartData = JSON.parse(JSON.stringify(topdeskData.value[activePie.value].pieChartData));
                pieChart.value.option.title.text = activePie.value;
                pieChart.value.option.legend.data = incidentPieChart.value.chartData.labels;
                pieChart.value.option.series[0].data = incidentPieChart.value.chartData.datasets;
                pieChart.value.option.series[0].name = "Incidents in Kategorie";
            }
        });

        onMounted(() => {
            getChartData();
        });

        return {
            error,
            pieChart,
            activePie,
            topdeskData,
            getChartData,
        }
    }
}
</script>

<style lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}
.chartCard {
    margin-bottom: 0;
    box-shadow: inherit !important;
}
</style>
